import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlertsNotificationDetails } from '../services/getNotificationByFilter'

export interface AlertsNotificationDataState {
  isLoading: boolean
  loadingError: string | undefined
  AlertsNotificationData: AlertsNotificationDetails[] | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: AlertsNotificationDataState = {
  isLoading: false,
  loadingError: undefined,
  AlertsNotificationData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const AlertsNotificationDataListState = createSlice({
  name: 'AlertsNotificationData',
  initialState,
  reducers: {
    AlertsNotificationDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        AlertsNotificationData: undefined,
        httpStatus: 0
      }
    },
    AlertsNotificationDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        AlertsNotificationData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertsNotificationDataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        AlertsNotificationData: undefined
      }
    }
  }
})

// Actions to export
export const {
  AlertsNotificationDataLoadingAction,
  AlertsNotificationDataUpdateAction,
  AlertsNotificationDataErrorAction
} = AlertsNotificationDataListState.actions

export default AlertsNotificationDataListState.reducer
